/**
 * Created by admin on 2017/1/10.
 */
import Vue from 'vue'
import Vuex from 'vuex'
import user from './common/user'
import homeState from './homeState'
import proDetails from'./proDetails'
import shopCart from'./shopCart'
import citys from './common/citys'
import addressState from'./addressState'
import orderState from'./orderManageState'
import orderDetails from'./orderDetailsState'
import expressList from'./orderExpressState'
import addressSelect from'./addressSelectState'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    user: user,
    homeState,
    proDetails,
    shopCart,
    citys,
    addressState,
    orderState,
    orderDetails,
    expressList,
    addressSelect
  }
})




// WEBPACK FOOTER //
// ./src/js/store/store.js